module.exports = __webpack_public_path__ + "img/multiply_red.a3396aef.png";